import apiBaseUrl from '../configs/app.config';
import { apiLogin } from './AuthService';

export async function AccountSignIn(userName, password) {
  try {
    const response = await apiLogin({
      emailOrCode: userName,
      password,
    });

    const { accessToken, refreshToken, sessionId, user, message, status } = response;

    return {
      status: Boolean(status),
      user,
      accessToken,
      refreshToken,
      sessionId,
      message,
    };
  } catch (error) {
    console.error('Login error', error);
    return {
      status: false,
      message: error?.response?.data?.message || error.message,
    };
  }
}

export async function AccountSignUp(object) {
  const response = await fetch(apiBaseUrl + 'Account/SignUp', {
    method: "POST",
    body: JSON.stringify({
      firstName: object.firstName,
      lastName: object.lastName,
      email: object.email,
      designation: object.designation,
      organization: object.organization,
      password: object.password,
      phoneNumber: object.phoneNumber,
      gender: object.gender,
      dob: object.dob,
      defaultCurrencyId: object.defaultCurrencyId,
      paymentCurrencyId: object.paymentCurrencyId,
    }),
    headers: {
      "Content-type": "application/json; charset=UTF-8"
    }
  });
  var data = await response.json();
  return data;
}

export async function apiChangePassword(object) {
  const response = await fetch(apiBaseUrl + 'Account/ChangePassword', {
    method: "POST",
    body: JSON.stringify({
      email: object.email,
      currentPassword: object.currentPassword,
      newPassword: object.newPassword,
    }),
    headers: {
      "Content-type": "application/json; charset=UTF-8"
    }
  })

  return response.json()
}

export async function apiForgotPassword (object) {

  let formData = new FormData();
  formData.append('Email', object.email);

  const response = await fetch(apiBaseUrl + 'Account/ForgetPassword',
  {
    body: formData,
    method: "post"
  });
  var data = await response.json();
  return data;
}

export async function apiResetPassword (object) {

  const response = await fetch(apiBaseUrl + 'Account/SetNewPassword', {
    method: "POST",
    body: JSON.stringify({
      id: object.id,
      token: object.token,
      password: object.password
    }),
    headers: {
      "Content-type": "application/json; charset=UTF-8"
    }
  });
  var data = await response.json();
  return data;
}
